// @mui
import { Container, Stack } from '@mui/material';
// components
import { ContactWidget } from '../../sections/web/home';
import { TeamWidget } from '../../sections/web/teams';
import { Seo } from '../../components/seo';

// ----------------------------------------------------------------------

export default function TeamsPage() {
  return (
    <>
      <Seo
        title="Healthcare Exam Mentors and Trainers"
        description="Meet the trainers, exam counsellors and placement specialists who mentor ASAP students through their DHA, MOH and HAAD licensing exams."
        path="/team"
      />

      <Container maxWidth="xl" sx={{ py: { xs: 4, md: 6 } }}>
        <Stack spacing={{ xs: 5, md: 8 }}>
          <TeamWidget titleComponent="h1" />

          <ContactWidget />
        </Stack>
      </Container>
    </>
  );
}
